import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

/** 
 * Very simple circular progress to use while loading data
*/
export const Loader = function () {
  return (
    <div className="appLoaderContainer">
      <div className="appLoader">
        <CircularProgress size={50} />
      </div>
    </div>
  );
}

/**
 * Component that displays a loader and hides its children until loading is false
 * @param {*} props 
 */
const Loading = props => {
  return props.loading ? <Loader {...props} /> : props.children;
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading.js